import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const replaceSubtext = (
  message: string,
  highlight: string,
  value: string = '',
): string => {
  if (!message.includes(highlight)) {
    return message;
  }
  return message.replace(highlight, value).trim();
};
